import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';

import { ActivityFormatService, AuthService, FestivalUserService } from '../../core/services';
import { FestivalUser } from 'src/core/models';
import { Activity } from 'src/core/enums';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.less']
})

export class LoginComponent implements OnInit {

  festivalUser$: Observable<FestivalUser[]>;

  email: string;
  password: string;
  serviceYear: string;

  constructor(
    private activityFormatService: ActivityFormatService,
    private authService: AuthService,
    private festivalUserService: FestivalUserService,
    private router: Router) {}

  ngOnInit() {
    this.serviceYear = environment.serviceYear;
  }

  async login() {

    if (!this.email)
      alert('Type in your email first');

    if (!this.password)
      alert('Type in your password first');

    await this.authService.loginInit(this.email, this.password).then(
      (userId) => { this.postLogin(userId) },
      (rejectionReason) => { alert(rejectionReason) })
    .catch(e => { alert('An error occurred while attempting to login') });
  }

  resetPassword() {

    if (!this.email)
      alert('Type in your email first');

    this.authService.resetPasswordInit(this.email).then(
      () => { 
        alert('A password reset link has been sent to your email address'); 
      },
      (rejectionReason) => { 
        alert(rejectionReason) 
      })
    .catch(e => { 
      alert('An error occurred while attempting to reset your password'); 
    });
  }

  async postLogin(userId: string) {
    
    this.festivalUser$ = await this.festivalUserService.getFestivalUser(userId);
    this.festivalUser$.subscribe(festivalUsers => {

      if(festivalUsers.length == 1) {
        const festivalUser = festivalUsers[0] as FestivalUser;
        this.festivalUserService.SetCurrentFestivalUser(festivalUser);

        if (festivalUser.isAdmin)
          this.router.navigate(['/userList']);
        else if (festivalUser.activityList != null && 
                 festivalUser.activityList.length > 0 && 
                 (festivalUser.isActivityCoordinator || festivalUser.isActivityApprover || festivalUser.isActivityLeader))
          this.navigateToActivityPerformances(festivalUser.activityList[0].value)
        else if (festivalUser.isSportCoordinator || festivalUser.isChurchApprover || festivalUser.isSportLeader)
          this.router.navigate(['/teamList']);
        else if (festivalUser.isMemberCoordinator)
          this.router.navigate(['/memberList']);
        else if (festivalUser.isReportViewer)
          this.router.navigate(['/reportList']);
        else
          this.router.navigate(['/memberList']);
      }
      else {
        this.router.navigate(['/no-access']);
      }
    });
  }

  private navigateToActivityPerformances = (activityStr: string): void => {
    var activityList = this.activityFormatService.getActivityList();
    const activity: string = activityList.find(a => a.value === activityStr).value;
    switch (activity) {
      case Activity.Choir: 
        this.router.navigate(['/choir/performanceList']);
        break;
      case Activity.Theatre: 
        this.router.navigate(['/theatre/performanceList']);
        break;
      case Activity.Media: 
        this.router.navigate(['/media/performanceList']);
        break;
      case Activity.IT: 
        this.router.navigate(['/it/performanceList']);
        break;
      case Activity.Research: 
        this.router.navigate(['/research/performanceList']);
        break;
      case Activity.VisualArts: 
        this.router.navigate(['/visualArt/performanceList']);
        break;
      // TODO: Add routes for other activities
      default: 
        break;
    }
  }
}
